import { render, staticRenderFns } from "./X-modale-contact.vue?vue&type=template&id=3dd1384a&scoped=true"
import script from "./X-modale-contact.vue?vue&type=script&lang=js"
export * from "./X-modale-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1384a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd1384a')) {
      api.createRecord('3dd1384a', component.options)
    } else {
      api.reload('3dd1384a', component.options)
    }
    module.hot.accept("./X-modale-contact.vue?vue&type=template&id=3dd1384a&scoped=true", function () {
      api.rerender('3dd1384a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chantier/X-modale-contact.vue"
export default component.exports